import React from 'react';
import {
    Table,
    TableHead,
    TableRow,
    TableCell,
    Button,
    ButtonGroup,
    TableFooter,
    TableBody,
    Dialog,
    DialogContent
} from '@material-ui/core';
import GroupingForm from './GroupingsForm';
import { useDeleteUnitTypeGrouping } from '~/groupings';

const GroupingTable = props => {

    const { data } = props;

    const { mutate: deleteGrouping } = useDeleteUnitTypeGrouping();
    const [open, setOpen] = React.useState(false);
    const [initialValues, setInitialValues] = React.useState(null);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
        <div style={{ maxWidth: '750px' }}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Name</TableCell>
                        <TableCell align='right'>Actions</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {(data.groupings || []).map(grouping => (
                        <TableRow key={grouping.id}>
                            <TableCell>
                                {grouping.name}
                            </TableCell>
                            <TableCell align='right'>
                                <ButtonGroup size='small'>
                                    <Button
                                        onClick={() => {
                                            setInitialValues(grouping);
                                            handleOpen();
                                        }}
                                    >
                                        Edit
                                    </Button>
                                    <Button onClick={() => deleteGrouping(grouping.id)}>Delete</Button>
                                </ButtonGroup>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
                <TableFooter>
                    <TableRow>
                        <TableCell />
                        <TableCell align='right'>
                            <Button
                                size='small'
                                onClick={() => {
                                    setInitialValues({ property_id: data.id });
                                    handleOpen();
                                }}
                                variant='contained'
                            >
                                New Grouping
                            </Button>
                        </TableCell>
                    </TableRow>
                </TableFooter>
            </Table>
            <Dialog fullWidth maxWidth='sm' open={open} onClose={handleClose}>
                <DialogContent>
                    <GroupingForm data={data} handleClose={handleClose} initialValues={initialValues}/>
                </DialogContent>
            </Dialog>

        </div>
    );


};

export default GroupingTable;
